import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetExamRequests,
	GetExamRequestsModel,
	GetExamRequestsParams,
} from 'domain/usecases/private/exam-results/get-exam-requests';

export class RemoteGetExamRequests implements GetExamRequests {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetExamRequestsModel>,
	) {}

	async get({signal, ...params}: GetExamRequestsParams): Promise<GetExamRequestsModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
